module.exports = __webpack_public_path__ + "img/visa.16670cef.svg";